export default __webpack_public_path__ + "static/media/NotoSans-Regular.e49f7cc8.ttf";